import Entity from '../entity';
export default class FlightSaleChannel extends Entity<string> {
  name: string;
}
